import React, { useCallback } from 'react';

// Material UI
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

// Data
import { SportTermLookup } from '../../../lib/types';
import { getImportPlayersMessages } from './import-players.messages';

// Components
import { FieldCaption } from '../../_core/_ui/field-caption.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';

export type JerseyRetentionChoice = 'UNCHANGED' | 'RETAIN' | 'RESET';

// The import's answer as the mutation takes it: unchanged sends nothing, so the setting is left alone.
export const jerseyRetentionAnswer = (choice: JerseyRetentionChoice): boolean | undefined => (
  choice === 'UNCHANGED' ? undefined : choice === 'RETAIN'
);

const FIELD_ID = 'import-players-jersey-retention';
const CAPTION_ID = `${FIELD_ID}-caption`;

interface IJerseyRetentionOptionsFieldProps {
  termLookup: SportTermLookup;
  choice: JerseyRetentionChoice;
  currentlyRetained: boolean;
  setChoice: (choice: JerseyRetentionChoice) => void;
}

export const JerseyRetentionOptionsField: React.FC<IJerseyRetentionOptionsFieldProps> = ({
  termLookup,
  choice,
  currentlyRetained,
  setChoice,
}) => {
  const messages = getImportPlayersMessages(termLookup);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => setChoice(event.target.value as JerseyRetentionChoice),
    [setChoice]
  );

  return (
    <Box m={2}>
      <Paper>
        <Box p={2}>
          <FieldCaption id={FIELD_ID}><IntlMsg {...messages.lblJerseyRetention} /></FieldCaption>
          <RadioGroup name={FIELD_ID} value={choice} onChange={handleChange} aria-labelledby={FIELD_ID} aria-describedby={CAPTION_ID}>
            <FormControlLabel
              value="UNCHANGED"
              control={<Radio />}
              label={<IntlMsg {...messages.optJerseyRetentionUnchanged} values={{
                current: <IntlMsg {...(currentlyRetained ? messages.currentJerseyRetentionOn : messages.currentJerseyRetentionOff)} />,
              }} />}
            />
            <FormControlLabel value="RETAIN" control={<Radio />} label={<IntlMsg {...messages.optJerseyRetentionRetain} />} />
            <FormControlLabel value="RESET" control={<Radio />} label={<IntlMsg {...messages.optJerseyRetentionReset} />} />
          </RadioGroup>
          <FieldCaption id={CAPTION_ID}><IntlMsg {...messages.captionJerseyRetention} /></FieldCaption>
        </Box>
      </Paper>
    </Box>
  );
};
